import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import CheckoutMain from "./CheckoutMain";
import Footer from "../../components/Footer";

const Checkout = () => {
  return (
    <>
      <HeaderFour />

      <CheckoutMain />

      <Footer />
    </>
  );
};

export default Checkout;
